import React from 'react';

import cx from 'classnames';

const SECURITY_TEXTS = [
  {
    id: 1,
    title: 'Physical Security',
    description:
      'We are hosted on AWS - one of the most trusted platforms which provides the most guaranteed uptime & physical data security.',
    icon: 'icon-integrations',
  },
  {
    id: 2,
    title: 'Integrations',
    description:
      'We implemented OAuth2 to securely integrate and authorize other cloud and SaaS services without any storage of your username, passwords.',
    icon: 'icon-alert',
  },
  {
    id: 3,
    title: 'Data Ownership',
    description:
      'Your Data is Yours 100%. It is never deleted and never accessed. If needed, you will have option to fully export it.',
    icon: 'icon-cloud',
  },
  {
    id: 4,
    title: 'Encryption',
    description:
      'All of the data is encrypted with SSL at rest using 256-bit AES encryption (same standards as top financial institutions).',
    icon: 'icon-binary-code',
  },
  {
    id: 5,
    title: 'Governance',
    description:
      'Established policies and procedures ensure that all of the staff is properly trained and role-based permissions.',
    icon: 'icon-padlock',
  },
  {
    id: 6,
    title: 'Data & Disaster Recovery',
    description:
      'Weekly full data backup schedule & multi-region databases provide for a maximum 24-hour RTO.',
    icon: 'icon-backup',
  },
  {
    id: 7,
    title: 'Data Utilization',
    description:
      'We never mine, sell or access your data for advertising or any other purposes.',
    icon: 'icon-computing',
  },
  {
    id: 8,
    title: 'Security & Privacy',
    description:
      'You are in full control of your privacy settings within the account with full abilities to assign permissions & controls for your team.',
    icon: 'icon-safety',
  },
  {
    id: 9,
    title: 'Data Privacy',
    description:
      'Your data is never accessed without your full written authorization.',
    icon: 'icon-fingerprint',
  },
];

export default function SecuritySection() {
  return (
    <section className="security-section">
      <div className="container">
        <div className="title">
          <span>Security</span>
        </div>
        <div className="row">
          {SECURITY_TEXTS.map(({ id, title, description, icon }) => (
            <div className="col">
              <div className="card">
                <div className="icon-box">
                  <div className={cx('icon', icon)} />
                </div>
                <div className="title-box">
                  <h4 className="subtitle">{title}</h4>
                </div>
                <div>{description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
